<template>
  <FourElement />
  <div class="collection-container">
    <List />
    <div v-if="dataSource && dataSource.length > 0">
      <div class="fs14 lh30 fl" style="color: #999999;">
        {{
          `共 ${pagination.total} 条记录，第${pagination.pageNum} / ${~~(
            pagination.total / pagination.pageSize
          ) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)}页`
        }}
      </div>
      <div
        style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
      >
        <a-pagination
          v-if="pagination.pageSize"
          class="mr20"
          v-model:current="pagination.pageNum"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :showTotal="() => false"
          :showSizeChanger="false"
          @change="initList"
        />
        <a-select
          class="mr10"
          style="min-width: 80px;"
          v-model:value="pagination.pageSize"
          @change="initList"
          placeholder="条"
          :options="[
            { value: 10, label: 10 },
            { value: 20, label: 20 },
            { value: 30, label: 30 },
            { value: 40, label: 40 },
            { value: 50, label: 50 }
          ]"
        >
        </a-select>
        <div class="lh30 mr10">条/页</div>
        <div class="lh30 mr10">跳转至</div>
        <a-input-number
          class="mr10"
          style="width: 50px;"
          :value="pagination.pageNum"
          placeholder="页"
          :max="
            pagination.total <= pagination.pageSize
              ? 1
              : Math.ceil(pagination.total / pagination.pageSize)
          "
          :min="1"
          @change="watchPage"
        />
        <div class="lh30">页</div>
      </div>
    </div>
  </div>
  <Log />
  <MixModal />
</template>
<script>
import { toRefs, reactive, provide, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import FourElement from './components/FourElement'
import List from './components/List'
import Log from './components/Log'
import MixModal from './components/MixModal'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
import { site_list_get } from 'server/modules/635'
const {
  mixCol_checkMixCol_post_,
  autoPopup_list_get_,
  autoPopup_delete_id_get_
} = useAPI(null, [3426, 4240, 5922, 10167])
export default {
  components: {
    FourElement,
    List,
    Log,
    MixModal
  },
  setup() {
    const state = reactive({
      warningAlert: true,
      mixParams: {
        peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
        mixId: null, // mixId，编辑时必传，新增不传
        colId: null // collectionId
      },
      mixPagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      mixVisible: false,
      mixDetailVisible: false,
      uniqueId: null,
      uniqueDic: [],
      getSiteList: async () => {
        const { success, data, retInfo } = await site_list_get()
        if (success) {
          console.log('data ', data)
          state.uniqueDic = data?.map(item => {
            return { ...item, value: item.uniqueId, label: item.uniqueName }
          })
        } else {
          message.error(retInfo)
        }
      },
      mixVisibleChange: (mixVisible = false) => {
        if (mixVisible) {
          state.handleReset()
          state.mixDetailVisible = false
          state.getMixList()
        }
        state.mixVisible = mixVisible
      },
      mixShowDetail: ({ mixId }) => {
        state.mixDetailVisible = true
        state.getMixDetail({ mixId })
      },
      checkMixCol: async (colId, mixType = 1) => {
        let params = {
          peerShowFlag: state.mixParams.peerShowFlag,
          ...state.searchParams,
          colId,
          mixType,
          mainColId: state.mixParams.colId
        }
        if (state.mixParams.mixId !== null) {
          params.mixId = state.mixParams.mixId
        }
        const { success, retInfo } = await mixCol_checkMixCol_post_({
          ...params
        })

        if (success) {
          console.log('')
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      checkLength: (key, len, text) => {
        switch (key) {
          case 'colId':
            if (
              state.mixParams.colId === null ||
              state.mixParams.colId === ''
            ) {
              message.warning('请填写混合商品Collection ID!')
            } else {
              state.mixParams.colId = state.mixParams.colId.substring(0, len)
            }
            break
          case 'colId_':
            if (text.colId === null || text.colId === '') {
              message.warning('请填写Collection ID!')
            } else {
              text.colId = text.colId.substring(0, len)
            }
            break
          case 'crossNum':
            if (
              text.crossNum === null ||
              text.crossNum === '' ||
              text.crossNum === 0
            ) {
              message.warning('穿插个数必填!')
            } else {
              text.crossNum = text.crossNum.substring(0, len)
            }
            break
        }
      },
      mixIndex: 0,
      mixCustomRow: (row, index) => {
        return {
          draggable: true,
          props: {
            draggable: true
          },
          sourceRowIndex: 0,
          onDragstart: e => {
            e.stopPropagation()
            state.mixIndex = index
          },
          onDragover: e => {
            e.preventDefault()
          },
          onDrop: e => {
            e.stopPropagation()
            const row = state.mixDataSource.splice(state.mixIndex, 1)
            state.mixDataSource.splice(index, 0, ...row)
          }
        }
      },
      clicked: false,
      hovered: false,
      handleHoverChange: visible => {
        state.clicked = false
        state.hovered = visible
      },
      handleClickChange: visible => {
        state.clicked = visible
        state.hovered = false
      },
      hide: () => {
        state.clicked = false
        state.hovered = false
      },
      watchPage: e => {
        state.pagination.pageNum = e
        state.initList()
      },
      inputLengthCut: ({ val = null, key = null, len = 0 }) => {
        if (!val) return
        let value = val.split('').splice(0, len)
        state.postParams[key] = value.join('')
        if (key === 'seoTitle') {
          console.log('val', val)
        }
        if (key === 'name') {
          // 如果是修改标题
          if (state.postParams.colSeo && state.postParams.colSeo.seoUrl) {
            state.inputLengthCut({
              val: state.postParams.colSeo.seoUrl,
              type: 'colSeo',
              key: 'seoUrl',
              len: 255,
              reg: true
            })
          }

          if (state.postParams.colSeo && state.postParams.colSeo.seoTitle) {
            state.inputLengthCut({
              val: state.postParams.colSeo.seoTitle,
              type: 'colSeo',
              key: 'seoTitle',
              len: 70
            })
          }
        }
      },
      deleteFun: params => {
        autoPopup_delete_id_get_(params, state.initList)
      },
      value: null,
      route: useRoute(),
      router: useRouter(),
      jumpPage: (path, query) => {
        console.log('query ', query)
        state.router.push({ path, query })
      },
      dataSource: [],
      searchParams: {
        uniqueId: 1
      },
      brands: [],
      channels: [],
      sites: [],
      postParams: {
        seoUrl: null,
        timeSet: [],
        name: null, // 标题
        colId: null, // 编码
        status: -1, // 状态
        shopifyColId: null, // shopfiy id
        createTimeBegin: null, // 开始时间
        createTimeEnd: null, // 结束时间
        colType: -1, // 类型
        creatorName: null, // 创建人
        remark: null, // 备注
        peopleGoodsFlag: -1,
        promotionFlag: -1,
        releationType: null
      },
      resetParams: () => {
        state.postParams = {
          seoUrl: null,
          timeSet: [],
          name: null, // 标题
          colId: null, // 编码
          status: -1, // 状态
          shopifyColId: null, // shopfiy id
          createTimeBegin: null, // 开始时间
          createTimeEnd: null, // 结束时间
          colType: -1, // 类型
          creatorName: null, // 创建人
          remark: null, // 备注
          peopleGoodsFlag: -1,
          promotionFlag: -1,
          releationType: null
        }
        state.initList()
      },
      changeFilterTime: timeSet => {
        state.postParams = {
          ...state.postParams,
          createTimeBegin:
            timeSet === null || timeSet.length === 0 ? null : timeSet[0],
          createTimeEnd:
            timeSet === null || timeSet.length === 0 ? null : timeSet[1]
        }
      },
      deletePeopleGoodsFlag: (params = {}) => {
        let newParams = { ...params }
        delete newParams.peopleGoodsFlag
        return newParams
      },
      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      resetPagination: () => {
        state.pagination = {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页的数量
          total: 0 // 总记录数
        }
        state.initList()
      },
      logList: [],
      logPagination: {
        pageNum: 1, // 当前页
        pageSize: 5, // 每页的数量
        total: 0 // 总记录数
      },
      formState: {},
      handleReset() {
        state.formState = {}
        state.handleQuery()
      },
      async handleQuery() {
        state.mixPagination.pageNum = 1
        state.getMixList()
      },
      changeRangePicker(date) {
        state.formState.updateTimeBegin = date[0]
        state.formState.updateTimeEnd = date[1]
      },
      initList: () => {
        autoPopup_list_get_(state)
      } // 初始化标题列表
    })
    onMounted(() => {
      if (state.route.query.uniqueId) {
        state.searchParams.uniqueId = state.route.query.uniqueId - 0
        state.router.replace({ query: {} })
      }
      state.getSiteList()
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
